export type Customer = {
	name: string;
	collectionIndicator: string;
	relatedParty: {
		individual: {
			contactMedium: any[];
			fullName: string;
			individualIdentification: {
				identificationId: string;
				type: string;
			};
			characteristic: {
				name: string;
				value: string;
			};
		};
	};
	characteristic: {
		name: string;
		value: string;
	}[];
	customerAccount?: CustomerAccount;
};

export type ProductSpecification = {
	productCategory: {
		type: string;
	};
	productSpecCharacteristic: {
		name: string;
		productSpecCharacteristicValue: {
			value: string;
		};
	};
};

export type SimDetail = {
	externalIdType?: string;
	serialNo?: string;
	statusId?: string;
};

export type ProductCharacteristic = {
	name: string;
	value: string;
};

export type CustomerAccountBalance = {
	status: string;
};

export type Result = {
	resultCode: string;
	resultDescription: string;
	resultTime: string;
};

export type Header = {
	operation: string;
	requestDate: string;
	requestId: string;
	requestingSystem: string;
	serviceName: string;
};

export type CustomerAccount = {
	id: string;
	status: string;
	customer: Customer;
	customerAccountBalance: CustomerAccountBalance;
	product: {
		productCharacteristic: ProductCharacteristic[];
		productSpecification: ProductSpecification;
		startDate: string;
		firstDataSim?: SimDetail;
		secondDataSim?: SimDetail;
		sawaSim?: SimDetail;
	};
};

export type CustomerAccountResponse = {
	customerAccount: CustomerAccount;
	header: Header;
	result: Result;
	isCPN: boolean;
};

const model = {
	header: 'response.getCustomerAccountResponse.header.serviceContext',
	result: 'response.getCustomerAccountResponse.result.result',
	customerAccount: 'response.getCustomerAccountResponse.customerAccount',
	isCPN: function(model: CustomerAccountResponse): boolean {
		return Boolean(
			model.customerAccount?.customer?.relatedParty?.individual?.characteristic?.name === 'CPN_ACCOUNT_NUMBER'
		);
	},
};

export default model;
